module.exports = __webpack_public_path__ + "ag.svg?f129acfd0b3096e2a702117096d88f9f";